import {postRequest} from "./postRequest";

export const executeQuery = async (key: string) => {
    return postRequest('/api/queries/execute', {"key": key})
};
